export const SET_CONVERSATION_QUESTION = 'SET_CONVERSATION_QUESTION'
